export default {"uiLoader":"_5izGv","loader":"_2MsgY"};